import { Event } from '@zajno/common/observing/event';
import { ILocation, INavigation, LocationChangedData, setNavigationInstance } from 'app/services/navigation';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

let prevLocation: ILocation = window.location;

const NoOpFn = (_route?: string) => { /* no-op */ };

const navigationInstance = {
    onPathChanged: new Event<LocationChangedData>(),
    goBack: NoOpFn,
    push: NoOpFn,
    replace: NoOpFn,
} satisfies INavigation;

setNavigationInstance(navigationInstance);

export const NavigatorProvider = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (prevLocation.pathname !== location.pathname) {
            navigationInstance.onPathChanged.trigger({ prev: prevLocation, next: location });

            prevLocation = location;
        }
    }, [location]);

    useEffect(() => {
        navigationInstance.goBack = () => navigate(-1);
        navigationInstance.push = route => navigate(route);
        navigationInstance.replace = route => navigate(route, { replace: true });

        return () => {
            navigationInstance.goBack = NoOpFn;
            navigationInstance.push = NoOpFn;
            navigationInstance.replace = NoOpFn;
        };
    }, [navigate]);

    return null;
};
